export const auth = {
  //switch login
  REFRESH_TOKEN: '/auth/auth/refresh-token',
  TOKEN_EXCHANGE: '/auth/auth/token-exchange',
  LOGOUT: '/auth/auth/logout'
}
export const iam = {
  // Lấy thông tin user
  USER_INFO: '/iam/user/userInfo',
  ALL_CLIENT: 'iam/client/findAll'
}

export const noti = {
  //Thông báo
  NOTI_APP_SEARCH: 'noti/noti-app/search',
  NOTI_APP_CREATE: 'noti/noti-app/create',
  NOTI_APP_DETAIL: 'noti/noti-app/self',
  NOTI_APP_GET_COUNT_UNREAD: 'noti/noti-app/count-unread',
  NOTI_APP_MARK_READ: 'noti/noti-app/mark-read'
}

export const crm = {
  //khách hàng
  CUSTOMER_SEARCH: 'crm/customer/search'
}

export const sys = {
  GET_COMPANY_LIST: 'sys/orgUnit/initTree',
  GET_PROVINCE: 'sys/location/find-province',
  GET_DISTRICT: 'sys/location/find-district',
  GET_COMMUNE: 'sys/location/find-commune',
  GET_GLOBAL_LIST_DETAIL: 'sys/globalListDetail/getListGlobalValueByCode',
  STAFF_SEARCH: 'sys/staff/search',
  CRM_BRANCH: 'sys/orgUnit/crm-v1/branch',
  STAFF_SEARCH_SYSTEM_CRM: 'sys/staff/crm-v1/responsible-staff'
}

export const wdn = {
  //phân vùng bản đồ
  MAP_PARTITION_CREATE: 'wdn/map-partition/create',
  MAP_PARTITION_UPDATE: 'wdn/map-partition/update',
  MAP_PARTITION_SEARCH: 'wdn/map-partition/search',
  MAP_PARTITION_DELETE: 'wdn/map-partition/delete',
  MAP_PARTITION_DETAIL: 'wdn/map-partition/self',
  MAP_PARTITION_TREE: 'wdn/map-partition/tree',

  //khu vực cấp nước
  DMX_SEARCH: 'wdn/dmx/search',
  DMX_GET_TREE: 'wdn/dmx/tree',
  DMX_CREATE: 'wdn/dmx/create',
  DMX_DETAIL: 'wdn/dmx/self',
  DMX_UPDATE: 'wdn/dmx/update',
  DMX_UPDATE_STATUS: 'wdn/dmx/update-status',
  DMX_DELETE: 'wdn/dmx/delete',
  DMX_GET_MASTER_METER: 'wdn/dmx/master-meter',
  DMX_UPDATE_MASTER_METER: 'wdn/dmx/update-master-meter',
  DMX_GET_CYCLE: 'wdn/dmx/cycle',
  DMX_GET_SUMMARY_CYCLE: 'wdn/dmx/summary-data-cycle',
  DMX_UPDATE_CYCLE: 'wdn/dmx/update-cycle',
  DMX_SEARCH_SYSTEM_CRM: 'wdn/dmx/crm-v1/search',
  DMX_MASTER_METER_ACTIVE: 'wdn/dmx-master-meter-active/search',

  //đồng hồ tổng
  MASTER_METER_SEARCH: 'wdn/master-meter/search',
  MASTER_METER_CREATE: 'wdn/master-meter/create',
  MASTER_METER_UPDATE: 'wdn/master-meter/update',
  MASTER_METER_UPDATE_STATUS: 'wdn/master-meter/update-status',
  MASTER_METER_DELETE: 'wdn/master-meter/delete',
  MASTER_METER_DETAIL: 'wdn/master-meter/self',
  MASTER_METER_GET_ASSIGN_DMC: 'wdn/master-meter/available-assign-dmc',
  MASTER_METER_GET_ASSIGN_DMX: 'wdn/master-meter/dmx',
  MASTER_METER_LATEST_DATA: 'wdn/master-meter-data/latest',
  MASTER_METER_DATA_HOUR: 'wdn/master-meter-data/data/search',
  MASTER_METER_DATA_HOUR_PRODUCTION: 'wdn/master-meter-data/data/hour',
  MASTER_METER_DATA_BY_DMA: 'wdn/master-meter-data/dma',
  MASTER_METER_DATA_DAY: 'wdn/master-meter-data/data/day',
  MASTER_METER_DATA_MONTH: 'wdn/master-meter-data/data/month',
  MASTER_METER_DATA_MIN_MAX: 'wdn/master-meter-data/data/min-max',

  // tuyến ống
  PIPE_SEARCH: 'wdn/pipe/search',
  PIPE_CREATE: 'wdn/pipe/create',
  PIPE_DETAIL: 'wdn/pipe/self',
  PIPE_UPDATE: 'wdn/pipe/update',
  PIPE_DELETE: 'wdn/pipe/delete',
  PIPE_IMPORT: 'wdn/pipe/request-import',
  PIPE_MC_CONFIRM: 'wdn/pipe/mc-confirm',
  PIPE_CORP_CONFIRM: 'wdn/pipe/corp-confirm',

  // datalogger
  DATALOGGER_SEARCH: 'wdn/datalogger/search',
  DATALOGGER_CREATE: 'wdn/datalogger/create',
  DATALOGGER_UPDATE: 'wdn/datalogger/update',
  DATALOGGER_UPDATE_STATUS: 'wdn/datalogger/update-status',
  DATALOGGER_DELETE: 'wdn/datalogger/delete',
  DATALOGGER_DETAIL: 'wdn/datalogger/self',
  DATALOGGER_LATEST_DATA: 'wdn/datalogger-data/latest',
  DATALOGGER_DATA_SEARCH: 'wdn/datalogger-data/search',

  // sensor
  SENSOR_SEARCH: 'wdn/sensor/search',
  SENSOR_CREATE: 'wdn/sensor/create',
  SENSOR_DETAIL: 'wdn/sensor/self',
  SENSOR_LATEST_DATA: 'wdn/sensor-data/latest',
  SENSOR_LATEST_DATA_SEARCH: 'wdn/sensor-data/search',
  SENSOR_UPDATE: 'wdn/sensor/update',
  SENSOR_UPDATE_STATUS: 'wdn/sensor/update-status',
  SENSOR_DELETE: 'wdn/sensor/delete',

  //van
  VALVE_CATALOG_SEARCH: 'wdn/valve/search',
  VALVE_CATALOG_CREATE: 'wdn/valve/create',
  VALVE_CATALOG_UPDATE: 'wdn/valve/update',
  VALVE_CATALOG_UPDATE_STATUS: 'wdn/valve/update-status',
  VALVE_CATALOG_DELETE: 'wdn/valve/delete',
  VALVE_CATALOG_DETAIL: 'wdn/valve/self',
  VALVE_CATALOG_IMPORT: 'wdn/valve/request-import',
  VALVE_DATA_SEARCH: 'wdn/valve-data/latest',
  VALVE_DATA_DETAILS: 'wdn/valve-data/search',
  VALVE_DATA_LATEST: 'wdn/valve-data/latest',

  //sản lượng đồng hồ
  MATER_METER_DATA_SEARCH: 'wdn/master-meter-data/search',
  MATER_METER_DATA_UPDATE: 'wdn/master-meter-data/update',
  MATER_METER_DATA_SEARCH_PRESSURE_DATA: 'wdn/master-meter-data/pressure/search',
  MATER_METER_DATA_GET_HISTORY_CHANGE_LIST: 'wdn/master-meter-data/history-change',
  MATER_METER_DATA_GET_IMAGES: 'wdn/master-meter-data/get-images',

  //Tổng hợp dữ liệu lượng đồng hồ
  GENERAL_MASTER_METER_DATA_SEARCH: 'wdn/master-meter-data/v2/search',
  GENERAL_MASTER_METER_DATA_UPDATE: 'wdn/master-meter-data/v2/upsert',

  //dữ liệu sản lượng nước cấp vào
  INPUT_WATER_DATA_SEARCH_BY_COMPANY: 'wdn/input-production-data-dmx/company/search',
  INPUT_WATER_DATA_SEARCH_BY_DMX: 'wdn/input-production-data-dmx/search',

  //dữ liệu sản lượng nước tiêu thụ
  WATER_CONSUMPTION_SEARCH_BY_COMPANY: 'wdn/consumption-production-data-dmx/company/search',
  WATER_CONSUMPTION_SEARCH_BY_DMX: 'wdn/consumption-production-data-dmx/search',

  //đồng hồ khách hàng
  METER_CUSTOMER_SEARCH: 'wdn/meter-c/search',
  METER_CUSTOMER_DETAIL: 'wdn/meter-c/self',
  METER_CUSTOMER_CREATE: 'wdn/meter-c/create',
  METER_CUSTOMER_UPDATE: 'wdn/meter-c/update',
  METER_CUSTOMER_DELETE: 'wdn/meter-c/delete',
  METER_CUSTOMER_IMPORT: 'wdn/meter-c/request-import',
  METER_CUSTOMER_UPDATE_STATUS: 'wdn/meter-c/update-status',
  METER_CUSTOMER_REQUEST_EXPORT: 'wdn/meter-c/request-export',

  //dữ liệu tiêu thụ đồng hồ khách hàng
  METER_CUSTOMER_DATA_SEARCH: 'wdn/meter-c-data/search',
  METER_CUSTOMER_DATA_GET_SUMMARY: 'wdn/meter-c-data/search-summary',
  METER_CUSTOMER_DATA_UPDATE: 'wdn/meter-c-data/update',
  METER_CUSTOMER_DATA_DELETE: 'wdn/meter-c-data/delete',
  METER_CUSTOMER_DATA_IMPORT: 'wdn/meter-c-data/request-import',

  //khấu trừ thất thoát
  DMX_LOSS_DEDUCT_SEARCH: 'wdn/dmx-loss-deduct/search',
  DMX_LOSS_DEDUCT_UPDATE: 'wdn/dmx-loss-deduct/update',

  //Áp lực theo địa bàn
  DMX_PRESSURE_DATA_SEARCH: 'wdn/dmx-pressure-data/search',
  DMX_PRESSURE_DATA_DETAIL: 'wdn/dmx-pressure-data/self',

  //các loại khấu trừ thất thoát
  LOSS_DEDUCT_TYPE_SEARCH: 'wdn/loss-deduct/search',
  LOSS_DEDUCT_TYPE_DETAIL: 'wdn/loss-deduct/self',
  LOSS_DEDUCT_TYPE_CREATE: 'wdn/loss-deduct/create',
  LOSS_DEDUCT_TYPE_UPDATE: 'wdn/loss-deduct/update',
  LOSS_DEDUCT_TYPE_DELETE: 'wdn/loss-deduct/delete',

  //Dữ liệu thất thoát theo khu vực
  DATA_LOSS_BY_DMX_SEARCH: 'wdn/dmx-water-loss/search',
  DATA_LOSS_BY_DMX_CALCULATE: 'wdn/dmx-water-loss/calculate',
  DATA_LOSS_BY_DMX_INFO: 'wdn/input-production-data-dmx/search-by-cycle',
  DATA_LOSS_BY_DMX_INFO_MASTER_METER: 'wdn/master-meter-data/search-by-time',

  DASHBOARD_WATER_LOSS_CONFIG_SEARCH: 'wdn/dashboard-water-loss-config/search',
  DASHBOARD_WATER_LOSS_CONFIG_UPDATE: 'wdn/dashboard-water-loss-config/update',

  //Nhà máy nước & trạm bơm
  //Nhà máy nước
  FPS_GET_FACTORY: 'wdn/factory/search',
  FPS_GET_DETAIL_FACTORY: 'wdn/factory/self',
  FPS_CREATE_FACTORY: 'wdn/factory/create',
  FPS_UPDATE_FACTORY: 'wdn/factory/update',
  FPS_DELETE_FACTORY: 'wdn/factory/delete',
  FPS_UPDATE_STATUS_FACTORY: 'wdn/factory/update-status',
  FPS_GET_DATALOGGER_FACTORY: 'wdn/factory-datalogger/search',
  FPS_UNASSIGNED_DATALOGGER_FACTORY: 'wdn/datalogger/unassigned-factory',
  FPS_GANT_DATALOGGER_FACTORY: 'wdn/factory/grant-datalogger',
  FPS_UPDATE_STATUS_DATALOGGER_FACTORY: 'wdn/factory-datalogger/update-status',
  FPS_FACTORY_DATA_LATEST: 'wdn/factory-datalogger/data/latest',
  FPS_FACTORY_DATALOGGER: 'wdn/factory-datalogger-p/search',
  FPS_FACTORY_DATALOGGER_UPDATE: 'wdn/factory-datalogger-p/update-batch',

  //Trạm xử lý
  FPS_GET_TREATMENT_PLANT: 'wdn/treatment-plant/search',
  FPS_GET_DETAIL_TREATMENT_PLANT: 'wdn/treatment-plant/self',
  FPS_CREATE_TREATMENT_PLANT: 'wdn/treatment-plant/create',
  FPS_UPDATE_TREATMENT_PLANT: 'wdn/treatment-plant/update',
  FPS_DELETE_TREATMENT_PLANT: 'wdn/treatment-plant/delete',
  FPS_UPDATE_STATUS_TREATMENT_PLANT: 'wdn/treatment-plant/update-status',
  FPS_GET_DATALOGGER_TREATMENT_PLANT: 'wdn/treatment-plant-datalogger/search',
  FPS_UNASSIGNED_DATALOGGER_TREATMENT_PLANT: 'wdn/datalogger/unassigned-treatment-plant',
  FPS_GANT_DATALOGGER_TREATMENT_PLANT: 'wdn/treatment-plant/grant-datalogger',
  FPS_UPDATE_STATUS_DATALOGGER_TREATMENT_PLANT: 'wdn/treatment-plant-datalogger/update-status',
  FPS_TREATMENT_PLANT_DATA_LATEST: 'wdn/treatment-plant-datalogger/data/latest',
  FPS_TREATMENT_PLANT_ASSIGN_DATALOGGER: 'wdn/treatment-plant-datalogger-p/search',
  FPS_TREATMENT_PLANT_ASSIGN_DATALOGGER_UPDATE: 'wdn/treatment-plant-datalogger-p/update-batch',

  //Trạm tăng áp
  FPS_GET_BOOSTER_STATION: 'wdn/booster-station/search',
  FPS_GET_DETAIL_BOOSTER_STATION: 'wdn/booster-station/self',
  FPS_CREATE_BOOSTER_STATION: 'wdn/booster-station/create',
  FPS_UPDATE_BOOSTER_STATION: 'wdn/booster-station/update',
  FPS_DELETE_BOOSTER_STATION: 'wdn/booster-station/delete',
  FPS_UPDATE_STATUS_BOOSTER_STATION: 'wdn/booster-station/update-status',
  FPS_GET_DATALOGGER_BOOSTER_STATION: 'wdn/booster-station-datalogger/search',
  FPS_UNASSIGNED_DATALOGGER_BOOSTER_STATION: 'wdn/datalogger/booster-station-plant',
  FPS_GANT_DATALOGGER_BOOSTER_STATION: 'wdn/booster-station/grant-datalogger',
  FPS_UPDATE_STATUS_DATALOGGER_BOOSTER_STATION: 'wdn/booster-station-datalogger/update-status',
  FPS_GET_BOOSTER_STATION_LATEST_DATA: 'wdn/booster-station-datalogger/data/latest',
  FPS_GET_BOOSTER_STATION_DATA_LOGGER_UPDATE: 'wdn/booster-station-datalogger-p/update-batch',
  FPS_GET_BOOSTER_STATION_DATA_LOGGER: 'wdn/booster-station-datalogger-p/search',

  //Theo dõi bất thường
  ANOMALY_MONITORING_ALERT_GROUP_CREATE: 'wdn/alert-group/create',
  ANOMALY_MONITORING_ALERT_GROUP_SEARCH: 'wdn/alert-group/search',
  ANOMALY_MONITORING_ALERT_GROUP_UPDATE: 'wdn/alert-group/update',
  ANOMALY_MONITORING_ALERT_GROUP_DELETE: 'wdn/alert-group/delete',
  ANOMALY_MONITORING_ALERT_GROUP_SELF: 'wdn/alert-group/self',

  ANOMALY_MONITORING_ALERT_UPDATE: 'wdn/alert/update',
  ANOMALY_MONITORING_ALERT_SEARCH: 'wdn/alert/search',
  ANOMALY_MONITORING_ALERT_SELF: 'wdn/alert/self',
  ANOMALY_MONITORING_ALERT_STATS: 'wdn/alert/stats/group',
  ANOMALY_MONITORING_ALERT_STATS_DMX: 'wdn/alert/stats/group/dmx',
  ANOMALY_MONITORING_ALERT_STATS_BY_STAFF: 'wdn/alert/stats/staff',
  ANOMALY_MONITORING_ALERT_STATS_DMZ: 'wdn/alert/stats/group/dmz',
  ANOMALY_MONITORING_ALERT_STATS_ORG: 'wdn/alert/stats/org',

  ANOMALY_MONITORING_ALERT_STATS_DNP: 'wdn/alert/stats/dnp',
  ANOMALY_MONITORING_ALERT_STATS_DNP_BY_ORG: 'wdn/alert/stats/dnp/stats-by-org',
  ANOMALY_MONITORING_ALERT_STATS_DNP_BY_ORG_LATEST: 'wdn/alert/stats/dnp/stats-by-org/latest',
  ANOMALY_MONITORING_ALERT_STATS_DNP_BY_TYPE: 'wdn/alert/stats/dnp/stats-by-type',
  ANOMALY_MONITORING_ALERT_STATS_BY_DMX: 'wdn/alert/stats/dmx',
  ANOMALY_MONITORING_ALERT_STATS_DMX_BY_ORG: 'wdn/alert/stats/dmx/stats-by-org',
  ANOMALY_MONITORING_ALERT_STATS_DMX_BY_ORG_LATEST: 'wdn/alert/stats/dmx/stats-by-type/latest',
  ANOMALY_MONITORING_ALERT_STATS_DMX_BY_TYPE: 'wdn/alert/stats/dmx/stats-by-type',
  ANOMALY_MONITORING_ALERT_IN_PROGRESS: 'wdn/alert/inProgress',
  ANOMALY_MONITORING_ALERT_COMPLETED: 'wdn/alert/complete',
  ANOMALY_MONITORING_ALERT_REFUSE: 'wdn/alert/refuse',

  ALERT_FLOW_DIFF: 'wdn/alert-flow-diff/search',

  //Cảnh báo mất kết nối thiết bị
  GET_DEVICE_CONNECT_LOSS_WARNING: 'wdn/alert-lost-connection/search',

  //Quản lý khung giờ sử dụng nước
  MANAGE_TIME_WATER_SEARCH: 'wdn/hour-level/search',
  MANAGE_TIME_WATER_UPDATE: 'wdn/hour-level/update',

  //Ban theo dõi dản lượng nền đêm
  TRACKING_PROD_NIGHTTIME_SEARCH: 'wdn/tracking-prod-nighttime/search',

  //Cấu hình cụm cấp nước
  WATER_SUPPLY_CLUSTER_CONFIG_SEARCH: 'wdn/dmc/search',
  WATER_SUPPLY_CLUSTER_CONFIG_DETAIL: 'wdn/dmc/self',
  WATER_SUPPLY_CLUSTER_CONFIG_CREATE: 'wdn/dmc/create',
  WATER_SUPPLY_CLUSTER_CONFIG_UPDATE: 'wdn/dmc/update',

  //Chênh lệch sản lượng
  PRODUCTION_DIFFERENCE_SEARCH: 'wdn/dmc-production-diff/search',
  PRODUCTION_DIFFERENCE_SEARCH_BY_HOUR: 'wdn/dmc-production-diff/hour/search',

  //Biểu đồ tương quan nguồn cấp và tiêu thụ
  CONSUMPTION_CORRELATION_CHART_GET_PRODUCTION_RATE: 'wdn/dashboard-supply-consume/production-rate',
  CONSUMPTION_CORRELATION_CHART_GET_PRESSURE_RATE: 'wdn/dashboard-supply-consume/pressure-rate',

  //đia giới hành chinh
  ADM_BOUNDARY_SEARCH: 'wdn/adm-boundary/search',
  ADM_BOUNDARY_DETAIL: 'wdn/adm-boundary/self',
  ADM_BOUNDARY_CREATE: 'wdn/adm-boundary/create',
  ADM_BOUNDARY_UPDATE: 'wdn/adm-boundary/update',
  ADM_BOUNDARY_DELETE: 'wdn/adm-boundary/delete',

  // Ngày nghỉ/lễ
  CALENDAR_SEARCH: 'wdn/calendar-config/search',
  CALENDAR_HISTORY: 'wdn/calendar-config/history-change',
  CALENDAR_UPDATE: 'wdn/calendar-config/update',

  //Van điều khiển
  VALVE_CONTROL_SEARCH: 'wdn/valve-control/search',
  VALVE_CONTROL_UPDATE_REQUEST: 'wdn/valve-control/update/request',
  VALVE_CONTROL_UPDATE_CONFIRM: 'wdn/valve-control/update/confirm',
  VALVE_CONTROL_DELETE: 'wdn/valve-control/delete',
  VALVE_CONTROL_HISTORY: 'wdn/valve-control/history-change',
  VALVE_CONTROL_ACTION: 'wdn/valve-control/control-history',
  VALVE_CONTROL_DETAIL: 'wdn/valve-control-detail/search',

  VALVE_CONTROL_ORG_SELF: 'wdn/valve-control-org/self',
  VALVE_CONTROL_ORG_UPDATE_STATUS: 'wdn/valve-control-org/update-status',

  // Lịch sử vận hành
  VALVE_CONTROL_HISTORY_CONTROL: 'wdn/valve-control-his/search',
  VALVE_CONTROL_SEARCH_SUMMARY: 'wdn/valve-control-his/search-summary',

  //Định mức khoán
  QUOTA_NORM_SELF: 'wfm/quota-norm/self'
}

export const wfm = {
  // Nhóm ticket
  TICKET_GROUP_SEARCH: 'wfm/ticket-group/search',
  TICKET_GROUP_CREATE: 'wfm/ticket-group/create',
  TICKET_GROUP_UPDATE: 'wfm/ticket-group/update',
  TICKET_GROUP_UPDATE_STATUS: 'wfm/ticket-group/update-status',
  TICKET_GROUP_DELETE: 'wfm/ticket-group/delete',
  TICKET_GROUP_DETAIL: 'wfm/ticket-group/self',

  // Loại ticket
  TICKET_TYPE_SEARCH: 'wfm/ticket-type/search',
  TICKET_TYPE_CREATE: 'wfm/ticket-type/create',
  TICKET_TYPE_UPDATE: 'wfm/ticket-type/update',
  TICKET_TYPE_UPDATE_STATUS: 'wfm/ticket-type/update-status',
  TICKET_TYPE_DELETE: 'wfm/ticket-type/delete',
  TICKET_TYPE_DETAIL: 'wfm/ticket-type/self',

  // Loại ticket theo đơn vị
  TICKET_TYPE_ORG_SEARCH: 'wfm/ticket-type-org/search',
  TICKET_TYPE_ORG_CREATE: 'wfm/ticket-type-org/create',
  TICKET_TYPE_ORG_UPDATE: 'wfm/ticket-type-org/update',
  TICKET_TYPE_ORG_UPDATE_STATUS: 'wfm/ticket-type-org/update-status',
  TICKET_TYPE_ORG_DELETE: 'wfm/ticket-type-org/delete',
  TICKET_TYPE_ORG_DETAIL: 'wfm/ticket-type-org/self',
  TICKET_TYPE_ORG_INIT: 'wfm/ticket-type-org/sync-ticket-type',
  TICKET_TYPE_ORG_DUE_TIME: 'wfm/ticket-type-org/due-date',

  TICKET_TYPE_CONFIG_TYPE_SEARCH: 'wfm/ticket-type-org-config/search',
  TICKET_TYPE_CONFIG_TYPE_UPDATE: 'wfm/ticket-type-org-config/update',

  TICKET_TYPE_REORDER: 'wfm/ticket-type-org/reorder',

  // Quản lý ticket
  TICKET_MANAGE_SEARCH: 'wfm/ticket/search',
  TICKET_MANAGE_DETAIL: 'wfm/ticket/self',
  TICKET_MANAGE_CREATE: 'wfm/ticket/create',
  TICKET_MANAGE_UPDATE: 'wfm/ticket/update',
  TICKET_MANAGE_DELETE: 'wfm/ticket/delete',
  TICKET_MANAGE_CANCEL: 'wfm/ticket/cancel',
  TICKET_MANAGE_PROCESS: 'wfm/ticket/inprogress',
  TICKET_MANAGE_COMPLETE: 'wfm/ticket/complete',
  TICKET_MANAGE_NEW: 'wfm/ticket/new',
  TICKET_MANAGE_GET_ACTIONS_LIST: 'wfm/ticket-comment/search',
  TICKET_MANAGE_CREATE_ACTIONS_LIST: 'wfm/ticket-comment/create',
  TICKET_MANAGE_GET_HISTORY_LIST: 'wfm/ticket/history-change',
  TICKET_MANAGE_PRINT_TICKET: 'wfm/ticket/print',
  TICKET_MANAGE_PRINT_MATERIAL: 'wfm/ticket/print-material',

  // Định mức khoán
  QUOTA_NORM_SELF: 'wfm/quota-norm/self',
  QUOTA_NORM_UPDATE: 'wfm/quota-norm/update',
  QUOTA_NORM_CREATE: 'wfm/quota-norm/create',

  //Quản lý khoán công việc
  PIECE_WAGE_MANAGE_SEARCH: 'wfm/piece-wage/search',
  PIECE_WAGE_MANAGE_CREATE: 'wfm/piece-wage/create',
  PIECE_WAGE_MANAGE_DETAIL: 'wfm/piece-wage/self',
  PIECE_WAGE_MANAGE_UPDATE: 'wfm/piece-wage/update',
  PIECE_WAGE_MANAGE_DELETE: 'wfm/piece-wage/delete',
  PIECE_WAGE_MANAGE_CONFIRM: 'wfm/piece-wage/confirm',
  PIECE_WAGE_MANAGE_UNCONFIRM: 'wfm/piece-wage/unconfirm',
  PIECE_WAGE_MANAGE_GET_DATA_PIECE_WAGE_BY_TICKET: 'wfm/piece-wage-ticket/search',
  PIECE_WAGE_MANAGE_CALC_DATA_BY_TICKET: 'wfm/piece-wage-ticket/calc',
  PIECE_WAGE_MANAGE_GET_DATA_PIECE_WAGE_SUM: 'wfm/piece-wage-sum/search',
  PIECE_WAGE_MANAGE_CALC_DATA_PIECE_WAGE_SUM: 'wfm/piece-wage-sum/calc',
  PIECE_WAGE_MANAGE_UPDATE_DATA_PIECE_WAGE_SUM: 'wfm/piece-wage-sum/update'
}

export const asm = {
  ASM_SEARCH: 'asm/asset/search'
}

export const fsm = {
  GET_FILE: 'fsm/file/list',
  UPLOAD_MULTIPART_FILE: 'fsm/file/upload-multipart'
}
